import { render, staticRenderFns } from "./Trailers.vue?vue&type=template&id=412449c7&"
import script from "./Trailers.vue?vue&type=script&lang=js&"
export * from "./Trailers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports